import { Component, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-cisco-admin-budgetcap-tab',
  templateUrl: './cisco-admin-budgetcap-tab.component.html',
  styleUrls: ['./cisco-admin-budgetcap-tab.component.scss']
})
export class CiscoAdminBudgetCapTabComponent {
  @Output() hideBudgetCap = new EventEmitter<void>();
}
